import Vue from 'vue'
import Vuex from 'vuex'
import decode from 'jwt-decode'
import router from '../router'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: null,
    user: null
  },
  mutations: {
    setToken(state,token)
    {
      state.token = token
    },
    setUser(state,user)
    {
      state.user = user
    }
  },
  actions: {
    saveToken({commit},token){
      commit("setToken",token)
      commit("setUser",decode(token))
      localStorage.setItem("token",token)
    },
    autoLogin({commit}){
      //For Doit 2FA, begin
      let token2;
      let user2;
      const url = window.location.href;
      //console.log(url,"-0-");  
      const urlObj = new URL(url);
      
      const parametros = urlObj.searchParams;
      var parametro1 = parametros.get('token'); // valor1
      //var parametro2 = parametros.get('list'); // valor2      

      if(parametro1){        
        parametro1 = parametro1.toString();
        parametro1 = parametro1.replace(/-/g,".");
        //user2 = parametro2.replace(/-/g,".");;
        token2 = parametro1;

        //console.log(token2,"-1-");  
        //console.log( user2,"-2-");  

        commit("setToken",token2)
        commit("setUser",decode(token2))
        localStorage.setItem("token",token2)

        router.push({name: 'Home'}).catch(err => {
          console.log('all good2')
          })    
      } else {
      //For Doit 2FA, end
      let token = localStorage.getItem("token");
      if (token) {
        commit("setToken",token)
        commit("setUser",decode(token))
      
        router.push({name: 'Home'}).catch(err => {
          console.log('all good')
          })    
      } else {
        router.push({name: 'Login'})

      }
    }  
    },
    exit({commit}){
      commit("setToken",null)
      commit("setUser",null)
      localStorage.removeItem("token")
      router.push({name: 'Login'})
    }
  },
  modules: {
  }
})
